<template>
  <div id="header">
    <div class="header-title">
      <h1>商越，用数字和连接让企业采购更简单</h1>
    </div>
    <div class="sub-nav syue-clr">
      <div class="logo"><img :src="logoUrl | imgHost"/></div>
      <!-- <div class="app-classify font-color-primary">
        <template
          v-for='(item, index) of appArr'
        >
          <div
            :class="['item', {current: current == index}]"
            :key="index"
          >
            <a :href="item.url">
              <i class="app-icon iconfont" v-html="'&#xe609;'"></i>
              <span class="app-name">{{ item.name }}</span>
            </a>
          </div>
        </template>
      </div> -->
      <div class="user">
        <span class="news" v-if="user.notice">
          <i></i>
          <span>消息</span>
        </span>
        <el-dropdown placement="bottom-start">
          <span class="portrait">
            <div class="pic" v-if="user.avatar">
              <img :src="syImgUrl + '1542958800725portrait%402x.png'">
            </div>
            <span>{{user.name || user.loginName}}<i class="el-icon-arrow-down el-icon--right"></i></span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <a :href="logout()">退出登录</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import Api from './api'
import response from 'fe-coms/utils/response'

export default {
  data () {
    return {
      user: {},
      logoUrl: null
    }
  },
  methods: {
    logout () {
      return `/userauth/userLogout/logout?clientType=mall&url=${encodeURIComponent(window.location.href)}&isMall=true`
    },
    async _getData () {
      let api = Api.publicHeader
      let res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        this.logoUrl = res.content.logoUrl
        this.user = res.content.userVo
      }
    }
  },
  created () {
    this._getData()
  }
}
</script>

<style lang="scss" scoped>
  @import '@/common/css/variable.scss';
  #header {
    min-width: 1200px;
    .header-title {
      height: 32px;
      background: $header-top-bgcolor;
      line-height: 32px;
      font-size: 12px;
      padding:0 20px;
      color: $header-top-color;
      h1 {
        font-size: 12px;
        font-weight: normal;
        color: #c7c7c7;
      }
    }
    .sub-nav {
      height: 64px;
      background: #fff;
      // box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      .logo {
        // width: 240px;
        max-height: 34px;
        float: left;
        margin-left: 20px;
        margin-top: 15px;
        margin-right: 30px;
        img {
          display: block;
          max-height: 34px;
        }
      }
      .app-classify {
        min-width: 500px;
        float: left;
        height: 100%;
        border-left: 2px solid $border-color;
        white-space: nowrap;
        overflow: hidden;
        .item {
          height: 100%;
          display: inline-block;
          margin-left: 28px;
          cursor: pointer;
          line-height: 64px;
          &.current a{
            color: currentColor;
          }
          a {
            display: block;
            color: $app-classify-color;
            font-size: 0;
            &:hover {
              color: currentColor;
            }
          }
          .app-icon {
            font-size: 24px;
            vertical-align: middle;
          }
          .app-name {
            font-size: 14px;
            font-weight: 400;
            vertical-align: middle;
            display: inline-block;
            margin-left: 5px;
            line-height: 1;
          }
        }
      }
      .user {
        float: right;
        color: #666;
        line-height: 64px;
        height: 64px;
        .portrait {
          padding-right: 30px;
          margin-right: 0;
          cursor: pointer;
          .pic {
            display: inline-block;
            border-radius: 50%;
            img {
              display:inline-block;
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 18px;
              vertical-align: middle;
            }
          }
        }
        .news {
          display: inline-block;
          height: 64px;
          line-height: 64px;
          margin-right: 34px;
          i {
            display:inline-block;
            width: 18px;
            height: 18px;
            font-style: normal;
            background: url($img-url + "1542957676161xiaoxi%402x.png") no-repeat;
            font-size: 12px;
            margin-right: 8px;
            vertical-align: middle;
          }
        }
      }
    }
  }
</style>
